import { appConfig } from '../../config';
import {
    jsonHeaderAuth,
    refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';


export const getRiwayatOrderByRow = async (length) => {
    const url = `${appConfig.BASE_API}/request/readbyRow/${localStorage.getItem('id')}/${length}`;
    // console.log('api link', url)
    const result = await axios.get(url, jsonHeaderAuth())
        .then(res => {
            console.log('getRiwayatOrderByRow', res.data)
            return res.data
        })
        .catch(error => {
            // console.log('error', error)
            return null;
        })
    return result

};

export const getRiwayatOrderByStatus = async (req) => {
    const url = `${appConfig.BASE_API}/request/readByStatus`;
    try {
        const res = await axios.post(url, req, jsonHeaderAuth())
        console.log('result read by status plain',res)
        console.log('result read by status',res.status,res.data)
        return{status: res.status, data: res.data}
    } catch (error) {
        console.log('error read by status',error)
        return { status: error.code, message: error.message }
    }
};

export const getRiwayatMemberByStatus = async (req) => {
    const url = `${appConfig.BASE_API}/requestmember/readByStatus`;
    try {
        const res = await axios.post(url, req, jsonHeaderAuth())
        return{status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
};


export const getDetailRiwayatOrder = async (id) => {
    try {
        const res = await axios.get(`${appConfig.BASE_API}/request/readdetail/${id}`, jsonHeaderAuth())

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
};

export const getImageRiwayatOrder = async (fileName) => {
    try {
        const response = await axios.get(`${appConfig.BASE_API}/image/tmp/${fileName}`, {
            ...jsonHeaderAuth(),
            responseType: 'blob'
        })

        const data = await response.data
        const dataUrl = URL.createObjectURL(data)

        // console.log('IMG : ',data)
        // console.log('IMG : ',dataUrl)
        return {status: response.status, data: dataUrl}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getTrackingRiwayat = async (id) => {
    // const url = `https://icareapi.astragraphia.co.id/serviceorder/${id}`;
    // console.log('api link get tracking riwayat', url)
    const result = await axios.get(`${appConfig.BASE_API}/serviceorder/${id}`, jsonHeaderAuth())
        .then(res => {
            // console.log('res tracking riwayat', res.data)
            return {status: res.status, data: res.data}
        })
        .catch(error => {
            return null;
        })
    return result
};

export const createReview = async (req) => {
    try {
        const {status, data} = await axios.post(`${appConfig.BASE_API}/request/review`, req, {
            ...jsonHeaderAuth()
        })

        return{status, data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getReviewByTRequestId = async (id) => {
    // console.log(id);
    try {
        const {status, data} = await axios.get(`${appConfig.BASE_API}/request/review/${id}`, {
            ...jsonHeaderAuth()
        })
        return{status, data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}


export const updateStatusId = async (id, req) => {
    try {
        const {status, data} = await axios.post(`${appConfig.BASE_API}/request/updatestatus/${id}`, req, {
            ...jsonHeaderAuth()
        })
        return{status, data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const insertNotifRequest = async (req) => {
    try {
        const {status,data} = await axios.post(`${appConfig.BASE_API}/notif/request/register`, req, {
            ...jsonHeaderAuth()
        })
        return{status,data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getRiwayatEmail = async (userid) => {
    try {
        const {status, data} = await axios.get(`${appConfig.BASE_API}/request/reademail/${userid}`, {
            ...jsonHeaderAuth()
        })
        return{status, data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getEmailByReqId = async (reqid) => {
    try {
        const {status,data} = await axios.get(`${appConfig.BASE_API}/request/reademailbyreqid/${reqid}`, {
            ...jsonHeaderAuth()
        })
        return {status, data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}